import { Alert } from "@interstate/components/Alert";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { StyledContainerAlert } from "./styled";

export interface MediaEndlinkErrorAlertProps {
  endlinkError: string | null;
  onClose: () => void;
}

export function MediaEndlinkErrorAlert({
  endlinkError,
  onClose
}: MediaEndlinkErrorAlertProps) {
  if (!endlinkError) return null;

  return (
    <StyledContainerAlert>
      <Alert
        data-testid="media-endlink-error-alert"
        displayCloseButton={true}
        id="MediaEndlinkErrorAlert"
        role="info"
        type="info"
        onCloseClick={onClose}
      >
        <span>{ErrorMessages.MEDIA_ENDLINK_ERROR}</span>
      </Alert>
    </StyledContainerAlert>
  );
}

export default MediaEndlinkErrorAlert;
